import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.201 8.7q1.625 0 2.762-1.138 1.139-1.137 1.138-2.762v-3h-7.8v3q0 1.625 1.137 2.762Q5.578 8.701 7.201 8.7M.908 19.2a.89.89 0 0 1-.645-.257.86.86 0 0 1-.262-.638.88.88 0 0 1 .26-.643.86.86 0 0 1 .64-.262h.6v-3q0-1.475.7-2.738A5.7 5.7 0 0 1 4.15 9.6a5.9 5.9 0 0 1-1.937-2.063A5.5 5.5 0 0 1 1.501 4.8v-3h-.6a.87.87 0 0 1-.64-.257A.86.86 0 0 1 0 .905q0-.38.26-.643A.86.86 0 0 1 .9 0h12.593q.382 0 .644.257a.86.86 0 0 1 .263.638.88.88 0 0 1-.259.642.86.86 0 0 1-.64.263h-.6v3q0 1.475-.714 2.737A5.9 5.9 0 0 1 10.251 9.6a5.7 5.7 0 0 1 1.95 2.062q.7 1.263.7 2.738v3h.6q.384 0 .641.257a.86.86 0 0 1 .26.638.88.88 0 0 1-.26.642.86.86 0 0 1-.64.263z"
    }, null, -1)
  ]))]))
}
export default { render: render }